import { render, staticRenderFns } from "./MedicalInsuranceLevelEdit.vue?vue&type=template&id=5106c06a&scoped=true&"
import script from "./MedicalInsuranceLevelEdit.vue?vue&type=script&lang=js&"
export * from "./MedicalInsuranceLevelEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5106c06a",
  null
  
)

export default component.exports